export default "__VITE_ASSET__DYWYyKR4__"